import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import ChatWidget from './ChatWidget';

// Floating chat bubble restricted to user ID 19
const ChatBubbleForUser19 = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const userId = user?.user_id || localStorage.getItem('user_id');
  const isTargetUser = String(userId) === '19';

  if (!isTargetUser) {
    return null;
  }

  return (
    <>
      {/* Floating chat bubble button */}
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 z-40 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg w-14 h-14 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        title="Open Helpdesk Chat"
      >
        <span className="sr-only">Open Helpdesk Chat</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l.8-4A7.964 7.964 0 013 12C3 7.582 7.03 4 12 4s9 3.582 9 8z"
          />
        </svg>
      </button>

      {/* Chat widget itself */}
      <ChatWidget isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default ChatBubbleForUser19;
